// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  height: 100px;
  background: #181A19;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  padding: 40px 100px;
}

@media (max-width: 1100px) {
  header {
    padding: 40px 50px;
    width: calc(100% - 100px);
  }
}
@media (max-width: 500px) {
  header {
    padding: 20px 20px;
    width: calc(100% - 40px);
  }
}
.home_button_img {
  width: 28px;
  height: 25px;
}

.out_button_img {
  width: 20px;
  height: 28px;
}

.home_button {
  cursor: pointer;
  border: none;
  background: #222423;
  width: 70px;
  height: 70px;
  border-radius: 16px;
}

footer {
  height: 167px;
  background: #181A19;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: 100%;
}

.buttons_container {
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

.img_logo_mini {
  width: 238px;
  height: 50px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/components.sass"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EAPA,mBAQ2B;EAP3B,aAOgC;EANhC,gBAMsC;EALtC,aAAA;EAMA,8BAAA;EACA,mBAAA;AAFF;;AAIA;EACE;IACE,kBAAA;IACA,yBAAA;EADF;AACF;AACA;EACE;IACE,kBAAA;IACA,wBAAA;EACF;AACF;AADA;EACE,WAAA;EACA,YAAA;AAGF;;AAFA;EACE,WAAA;EACA,YAAA;AAKF;;AAJA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAOF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AASF;;AAPA;EA1CE,mBA2C2B;EA1C3B,aA0CgC;EAzChC,gBAyCsC;EAxCtC,aAAA;AAqDF;;AAVA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAaF","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\nheader\n  height: 100px\n  background: #181A19\n  @include default_container(row, 10px, 10px)\n  justify-content: space-between\n  padding: 40px 100px\n\n@media (max-width: 1100px)\n  header\n    padding: 40px 50px\n    width: calc(100% - 100px)\n@media (max-width: 500px)\n  header\n    padding: 20px 20px\n    width: calc(100% - 40px)\n.home_button_img\n  width: 28px\n  height: 25px\n.out_button_img\n  width: 20px\n  height: 28px\n.home_button\n  cursor: pointer\n  border: none\n  background: #222423\n  width: 70px\n  height: 70px\n  border-radius: 16px\nfooter\n  height: 167px\n  background: #181A19\n  display: flex\n  position: fixed\n  bottom: 0\n  z-index: 1\n  width: 100%\n\n.buttons_container\n  @include default_container(row, 10px, 10px)\n\n\n.img_logo_mini\n  width: 238px\n  height: 50px\n  margin-top: 10px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
